export const getLocationLink = (subdomain: string) => {
    let currentLink = window.location.origin
    var regex = /(https:\/\/|http:\/\/)([a-zA-Z0-9-]*)/
    let link = currentLink
    var matches = currentLink.match(regex)
    if (matches?.[2]) link = currentLink.replace(matches[2], subdomain)
    return link
}
